import React from "react";
import { StyledFlexDiv } from "../../../styles/MainStyles";
import {
    StyledLegendTitle,
    StyledSquareLegend,
} from "../../../styles/pages/Schedule/ScheduleStyle";

interface ILegendItemColor {
    title?: string;
    color?: string;
}

const LegendItemColor: React.FC<ILegendItemColor> = ({
    title = "",
    color = "",
}) => {
    return (
        <StyledFlexDiv style={{ margin: "0.5rem 0" }}>
            <StyledSquareLegend style={{ background: color }} />
            <StyledLegendTitle>{title}</StyledLegendTitle>
        </StyledFlexDiv>
    );
};

export default LegendItemColor;
